export const html = `<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="preconnect" href="https://fonts.gstatic.com" />
  <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap"
    rel="stylesheet" />
  <title>date-weekday-DISPATCH SHEET</title>
</head>
<style>
  body {
    width: 100%;
    margin: 0 auto;
    padding: 1.6cm;
    box-sizing: border-box;
    font-family: Roboto;
  }

  .container {
    width: 100%;
  }

  @media print {
    body {
      -webkit-print-color-adjust: exact;
    }
  }

  .header {
    font-style: normal;
    text-align: center;
    font-weight: 600;
  }

  .divider {
    border: 1px solid #000000;
  }

  .signature {
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  .spacer {
    flex: 1;
  }

  .underline {
    width: 200px;
    margin-left: 10px;
    margin-top: 8px;
    border-bottom: 1px solid #000000;
  }

  @media print {
    @page {
      margin: 0;
      margin-top: 0.8cm;
      size: landscape;
    }

    .container {
      width: calc(100% - 20px);
    }

    table {
      table-layout: fixed;
      width: calc(100% - 20px);
    }

    body {
      margin: 10px;
      padding: 0px;
      margin-top: 0px;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  table thead {
    background: #e6e6e6;
    font-size: 10px;
  }

  table tr,
  table td {
    font-size: 10px;
    padding: 15px 10px;
  }

  table th,
  table td {
    border: 1px solid lightgray;
  }

  table th {
    padding: 15px 10px;
    text-align: left;
  }

  .row {
    display: flex;
  }

  .dispatch_total {
    background: lightgrey;
    padding: 10px;
    border: 1px solid grey;
  }

  .col {
    padding: 10px;
    font-weight: bold;
    display: flex;
    flex: 1;
  }

  .col:nth-child(2) {
    justify-content: flex-end;
  }

  .col div {
    width: 200px;
    margin-right: 10px;
  }

  .technician {
    padding: 15px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    background: lightgray;
  }
</style>

<body>
  <div class="container">
    <h4 class="header">
      EL CHEAPO 24 HOUR MOBILE LOCKSMITH & ROAD SERVICES<br />
      3026 Midway drive, San Diego CA 92110<br />
      Locksmith license LCO#7316
    </h4>
    <div class="divider"></div>
    <div class="signature">
      <h4>
        DATE: date weekday
      </h4>
      <div class="spacer"></div>
      <h4 class="date">DISPATCH SHEET</h4>
    </div>
    <div class="dispatch_total">
      <div class="row">
        <div class="col">
          <div>
            Total Daily Gross Cash
          </div>
          <span>
            $total_cash
          </span>
        </div>
        <div class="col" style="text-align:right">
          <div>
            EL Cheapo Total Daily Sales
          </div>
          <span>
            $total_sale
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>
            Total Credit Card Charges
          </div>
          <span>
            $total_card_charge
          </span>
        </div>
        <div class="col" style="text-align:right">
          <div>
            On Account
          </div>
          <span>
            $on_account
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>
            Approved Check
          </div>
          <span>
            $approved_check
          </span>
        </div>
        <div class="col" style="text-align:right">
          <div>
            Zelle Cash
          </div>
          <span>
            $zelle_cash
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>
            Total Reimbursements
          </div>
          <span>
            $total_reimbusements
          </span>
        </div>
        <div class="col" style="text-align:right">
        </div>
      </div>
    </div>

    technicians
  </div>
</body>

</html>
`;
export const table = `<div class="technician">
  name
  <span>

    total_commission
  </span>
</div>
<table>
  <thead>
    <tr>
      <th>
        Job #
      </th>
      <th>
        Tech Confirmation
      </th>
      <th>
        Invoice #
      </th>
      <th>
        Job Type
      </th>
      <th>
        Job Status
      </th>
      <th>
        How Paid
      </th>
      <th>
        Quoted Flat Rate $
      </th>
      <th>
        Tech Total Collected
      </th>
      <th>
        Credit Card Fee $
      </th>
      <th>
        Reimbursement $
      </th>
      <th>
        Net Sales $
      </th>
      <th>
        Tech.
        Commission
      </th>
      <th>
        cheapo_commission
      </th>
      <th>
        Disposition
      </th>
      <th>
        Deposited
      </th>
    </tr>
  </thead>
  <tbody>
    table_body
  </tbody>
</table>`;
